export const drivingCourses = [
    {
        id: 1,
        title: "МИНИМАЛЬНЫЙ",
        description: "Для тех, кто уже умеет водить, но хочет разобраться в ПДД и официально подтвердить новым перед сдачей в ГАИ",
        price: "29 900 ₽",
        paymentOptions: ["Оплата сразу", "Частями на 3 месяца"],
        features: [
            "✓ Теория полностью онлайн: обучение и внутренний экзамен в мобильном и веб-приложениях",
            "✓ Сопровождение на экзамен в ГАИ"
        ],
        drivingHours: "16",
        color: "#000000" // Черный
    },
    {
        id: 2,
        title: "СРЕДНИЙ",
        description: "Для тех, кто учится на права с нуля. Могут понадобиться дополнительные занятия с инструктором",
        price: "37 900 ₽",
        paymentOptions: ["Оплата сразу", "Частями на 3 месяца"],
        features: [
            "✓ Теория полностью онлайн: обучение и внутренний экзамен в мобильном и веб-приложениях",
            "✓ Сопровождение на экзамен в ГАИ"
        ],
        drivingHours: "30",
        color: "#FF6F00" // Оранжевый
    },
    {
        id: 3,
        title: "МАКСИМАЛЬНЫЙ",
        description: "Для тех, кто хочет быть уверенным за рулём и иметь максимальные шансы на сдачу экзаменов с первого раза",
        price: "49 900 ₽",
        paymentOptions: ["Оплата сразу", "Частями на 3 месяца"],
        features: [
            "✓ Теория полностью онлайн: обучение и внутренний экзамен в мобильном и веб-приложениях",
            "✓ Сопровождение на экзамен в ГАИ"
        ],
        drivingHours: "56/54",
        color: "#0984FF" // Синий
    }
];

export const drivingCoursesA = [
    {
        id: 1,
        title: "МИНИМАЛЬНЫЙ",
        description: "Для тех, кто уже умеет водить, но хочет разобраться в ПДД и официально подтвердить новым перед сдачей в ГАИ",
        price: "37 900 ₽",
        paymentOptions: ["Оплата сразу", "Частями на 3 месяца"],
        features: [
            "✓ Теория полностью онлайн: обучение и внутренний экзамен в мобильном и веб-приложениях",
            "✓ Сопровождение на экзамен в ГАИ",
            "✓ Круглогодичное вождение",
            "✓ Круглогодичная сдача экзаменов",
        ],
        drivingHours: "10",
        color: "#FF6F00" // Черный
    },
    {
        id: 2,
        title: "МАКСИМАЛЬНЫЙ",
        description: "Для тех, кто хочет быть уверенным за рулём и иметь максимальные шансы на сдачу экзаменов с первого раза",
        price: "47 900 ₽",
        paymentOptions: ["Оплата сразу", "Частями на 3 месяца"],
        features: [
            "✓ Теория полностью онлайн: обучение и внутренний экзамен в мобильном и веб-приложениях",
            "✓ Сопровождение на экзамен в ГАИ",
            "✓ Круглогодичное вождение",
            "✓ Круглогодичная сдача экзаменов",
        ],
        drivingHours: "16",
        color: "#0984FF" // Синий
    }
]